import Icon from 'helpers/svg-icon';
import { cefRed, information, ctaGreen } from 'constants/variables';

const CircleTick = ({
  fillColorMain,
  fillColorSecondary,
  v2ProductDetail,
  width = 20,
  height = 20,
  ...rest
}) => (
  <Icon
    viewBox="0 0 28 28"
    className={v2ProductDetail && 'mr-05'}
    width={width}
    height={height}
    {...rest}>
    <path
      d="M26 14c0 6.629-5.371 12-12 12S2 20.629 2 14 7.371 2 14 2s12 5.371 12 12zm0 0"
      fill={fillColorMain}
    />
    <path
      d="M20.3 10.5L18.8 9l-.3.3-6.102 6.098-3.296-3.296-.301.296-1.102
      1.204-.3.398.3.3 4.403 4.4.296.3.301-.3 7.602-7.598.3-.301zm0 0"
      fill={fillColorSecondary}
    />
  </Icon>
);

const ClassicTick = ({
  fillColor = ctaGreen,
  width = 55,
  height = 55,
  ...rest
}) => (
  <Icon
    viewBox="0 0 71.2 54.6"
    x="0px"
    y="0px"
    width={width}
    height={height}
    {...rest}>
    <polygon
      style={{ fill: fillColor }}
      points="69.6,8.4 63.2,2.1 61.5,0.4 59.8,2.1 27.1,34.8 11,18.8 9.3,17 7.6,18.9 1.5,25.6 0,27.2 1.6,28.8
  25.4,52.6 27.1,54.2 28.8,52.6 69.6,11.8 71.2,10.1 "
    />
  </Icon>
);

const Circle = ({ fill = '#ffffff', width = 10, height = 10 }) => (
  <Icon fill="none" width={width} height={height} viewBox="0 0 10 10">
    <rect width="10" height="10" fill={fill} rx="5" />
  </Icon>
);

const Donut = ({ fill = '#ffffff', width = 10, height = 10 }) => (
  <Icon fill="none" width={width} height={height} viewBox="0 0 10 10">
    <rect width="10" height="10" fill={fill} rx="5" />
    <circle cx="5" cy="5" r="1.5" fill="#fff" />
  </Icon>
);

const InfoIcon = ({
  fillColor = information,
  width = 18,
  height = 18,
  ...rest
}) => (
  <Icon height={height} width={width} viewBox="0 0 18.801 18.801" {...rest}>
    <circle cx="9.5" cy="9.5" fill="#fff" r="6.5" />
    <path
      d="m13.4 4a9.4 9.4 0 1 0 9.4 9.4 9.4 9.4 0 0 0 -9.4-9.4zm-.992 4.966h1.992v1.712h-1.993zm3.006 8.865h-4.03v-1.763h1.038v-2.555h-1.038v-1.762h3.016v4.318h1.013z"
      fill={fillColor}
      transform="translate(-4 -4)"
    />
  </Icon>
);

const WarningTriangle = ({
  fillColor = cefRed,
  width = 42.995,
  height = 37.225,
  ...rest
}) => (
  <Icon viewBox="0 0 42.995 37.225" width={width} height={height} {...rest}>
    <path
      fill={fillColor}
      id="Path_10550"
      data-name="Path 10550"
      d="M21.5,0,0,37.225H43Zm2.981,15.664-.634,9.385H19.088l-.634-9.385Zm-.507,16.424H19.088V27.4h4.883Z"
    />
  </Icon>
);

const CircleCrossIcon = ({
  width = 20,
  height = 20,
  fillColorMain,
  fillColorSecondary,
  ...rest
}) => (
  <Icon viewBox="0 0 64 64" width={width} height={height} {...rest}>
    <g transform="translate(-861 -754)">
      <circle cx="893" cy="786" r="32" fill={fillColorMain} />
      <path
        fill={fillColorSecondary}
        d="M909.6,797.6l-11.9-11.9l11.9-11.9l-5-5l-11.9,11.9l-11.9-11.9l-5,5l11.9,11.9l-11.9,11.9l5,5
    l11.9-11.9l11.9,11.9L909.6,797.6z"
      />
    </g>
  </Icon>
);

export {
  WarningTriangle,
  ClassicTick,
  Circle,
  Donut,
  InfoIcon,
  CircleTick,
  CircleCrossIcon,
};
